import LegalPageLayout from "./LegalPageLayout";
import { Mail, LifeBuoy, MessageCircle } from "lucide-react";

const RESOURCES = [
  {
    icon: Mail,
    title: "Nous écrire",
    description: "Une question, un bug, une suggestion ? Notre équipe te répond sous 48h.",
    action: "support@theecho.fr",
    href: "mailto:support@theecho.fr",
    testid: "support-email",
  },
  {
    icon: LifeBuoy,
    title: "Centre d'aide",
    description: "Retrouve les réponses aux questions les plus fréquentes sur l'application.",
    action: "Consulter la FAQ",
    href: "mailto:support@theecho.fr?subject=Question%20FAQ",
    testid: "support-faq",
  },
  {
    icon: MessageCircle,
    title: "Signaler un problème",
    description: "Un souci technique avec l'application ? Fais-le nous savoir directement.",
    action: "Signaler",
    href: "mailto:support@theecho.fr?subject=Signalement%20d'un%20probl%C3%A8me",
    testid: "support-report",
  },
];

export default function SupportPage() {
  return (
    <LegalPageLayout
      title="Support"
      subtitle="Nous sommes là pour t'aider dans ton glow up mental"
      testid="page-support"
    >
      <section>
        <p>
          Notre équipe est disponible pour répondre à toutes tes questions concernant Echo, ton
          compte, ton abonnement ou l&apos;utilisation de l&apos;application.
        </p>
      </section>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 not-prose mt-4">
        {RESOURCES.map((r) => {
          const Icon = r.icon;
          return (
            <a
              key={r.title}
              href={r.href}
              data-testid={r.testid}
              className="group block rounded-2xl glass p-6 hover:border-white/20 hover:bg-white/[0.05] hover:-translate-y-1 transition-all duration-300"
            >
              <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-[#9D4CDD]/30 to-[#6D28D9]/20 border border-white/10 flex items-center justify-center mb-4">
                <Icon className="w-5 h-5 text-white" strokeWidth={1.8} />
              </div>
              <h3 className="text-lg font-bold text-white mb-1.5">{r.title}</h3>
              <p className="text-sm text-white/60 leading-relaxed mb-3">{r.description}</p>
              <span className="text-sm text-[#B47CE8] font-semibold group-hover:text-white transition-colors">
                {r.action} →
              </span>
            </a>
          );
        })}
      </div>

      <section>
        <h2>Horaires</h2>
        <p>
          Notre équipe support répond du lundi au vendredi, de 9h à 18h (heure de Paris).
          Nous nous efforçons de répondre à toutes les demandes sous 48h ouvrées.
        </p>
      </section>
    </LegalPageLayout>
  );
}
